import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/admindashboard/_layout/classes")({
  validateSearch: z.object({
    searchFrom: z.string().date().optional(),
    searchTo: z.string().date().optional(),
    tutors: z.array(z.string().uuid()).optional(),
    status: z.boolean().optional(),
  }),
});
